import { LatLng } from 'shared/types';

export const FLOOD_CATEGORIES = {
  major: 'major',
  moderate: 'moderate',
  minor: 'minor',
  action: 'action',
  normal: 'normal',
  none: 'none',
} as const;

export type FloodCategory =
  (typeof FLOOD_CATEGORIES)[keyof typeof FLOOD_CATEGORIES];

export type FloodCategoryLevel = {
  category: FloodCategory;
  level: number;
};

export type FloodImpact = {
  level: number;
  statement: string;
};

export type WaterLevelSummary = {
  id: number;
  name: string;
  units: {
    level: string;
    flow: string;
  };
  weatherStationType: 'waterLevel';
};

export type WaterLevel = {
  id: number;
  name: string;
  usgsId: string;
  noaaLid: string;
  floodCategories: FloodCategoryLevel[];
  floodImpacts: FloodImpact[];
  units: {
    level: string;
    flow: string;
  };
  location: LatLng;
  isOffline: boolean;
};

export type WaterLevelObservation = {
  timestamp: Date;
  flow: number;
  level: number;
};
